import { render, staticRenderFns } from "./Detail-Services.vue?vue&type=template&id=349f8503&"
import script from "./Detail-Services.vue?vue&type=script&lang=js&"
export * from "./Detail-Services.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Services.vue?vue&type=style&index=0&id=349f8503&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports